import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import { ClientType, getClient } from "./client-registry";

export const instance = <TData = unknown, TVariables = unknown>(
  config: AxiosRequestConfig<TVariables>,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<TData>> => {
  return getClient(ClientType.Auth).request<TData>({
    ...config,
    ...options,
    headers: {
      ...config.headers,
      ...options?.headers,
    },
  });
};

export type ErrorType<Error> = AxiosError<Error>;
